/** Fixed-capacity recycling storage for cosmetic effects. Capacity comes from validated data. */
export class FxPool<T extends object> {
  readonly items: T[] = [];
  private next = 0;
  constructor(readonly capacity: number) {
    if (!Number.isInteger(capacity) || capacity < 1) throw new Error('Invalid FX capacity');
  }
  put(value: T): T {
    if (this.items.length < this.capacity) { this.items.push(value); return value; }
    const item = this.items[this.next]; Object.assign(item, value);
    this.next = (this.next + 1) % this.capacity; return item;
  }
}

/** Give an acknowledged flash one rendered frame on slow devices; never revive stale events. */
export function flashStrength(f: { at: number; shown?: boolean }, time: number, duration: number, grace: number): number {
  const age = time - f.at;
  if (age < 0 || age > grace) return 0;
  if (!f.shown) { f.shown = true; return 1; }
  return Math.max(0, 1 - age / duration);
}
